export default "__VITE_ASSET__BKT$zUjB__"